export default "__VITE_ASSET__d938bc3e__"